import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { getUrlParam } from 'utils/urlUtils';

import { DEFAULT_THEME } from 'constants/index';

import {
  getContext, getOrigin, hasShareboxStyle, isRemoteKiosk,
} from 'modules/dealers/selectors';
import { getContext as getVCContext } from 'modules/vehicleCheck/selectors';

export const getAppTheme = createDraftSafeSelector(
  getContext,
  getVCContext,
  (context, vcContext) => {
    let theme = getUrlParam('theme');

    if (!theme) {
      theme = context?.theme ?? vcContext?.theme;
    }

    return theme ?? DEFAULT_THEME;
  },
);

export const getAppOrigin = createDraftSafeSelector(
  getOrigin,
  hasShareboxStyle,
  isRemoteKiosk,
  (origin, shouldApplyShareboxStyle, isRemote) => {
    if (isRemote) {
      return 'REMOTE_KIOSK';
    }

    if (shouldApplyShareboxStyle) {
      return 'SHAREBOX_INDOOR_KIOSK';
    }

    return origin ?? '';
  }
  ,
);

export const isLowPerfMode = hasShareboxStyle;
